import { jsx } from "react/jsx-runtime";
import { ColumnFocusWrapper } from "./ColumnFocusStyles.js";
import { useColumnSelectionContext } from "../../../context/useColumnSelectionContext.js";
import { useColumns } from "../../../context/useColumnsContext.js";
const ColumnFocus = ({
  isFirstColumn,
  column
}) => {
  var _a;
  const { focusedColumn } = useColumnSelectionContext();
  const { columnStyles, columnValueToIndex } = useColumns();
  const configKey = column.value ?? "";
  const isFocused = focusedColumn === configKey;
  const leftBorderOffset = isFirstColumn ? 1 : 0;
  if (!isFocused)
    return null;
  const columnIndex = columnValueToIndex[configKey];
  const width = ((_a = columnStyles[columnIndex]) == null ? void 0 : _a.width) ?? 0;
  return /* @__PURE__ */ jsx(ColumnFocusWrapper, { leftOffset: leftBorderOffset, width });
};
export {
  ColumnFocus
};
